module.exports = {
  DEDU_DATA_FETCH_COMMAND: {
    name: 'DeduDataFetch',
    description: 'Fetch Dedu data',
    frequency: '0 9 * * *',
  },
  DEDU_ENROLLMENT_FETCH_COMMAND: {
    name: 'DeduEnrollmentFetch',
    description: 'Fetch Dedu Enrollment data',
    frequency: '*/15 * * * *',
  },
  EMAIL_COMMAND: {
    name: 'Email',
    description: 'Send email',
    frequency: '* * * * *',
  },
  EMAIL_TRACKING_UPDATE_COMMAND: {
    name: 'EmailTrackingUpdate',
    description: 'Update email tracking',
    frequency: '0 19 * * * ',
  },
  EMIT_PERSONIFY_REWARD_EVENTS: {
    name: 'EmitPersonifyRewardEvents',
    description: 'Posts pending Personify reward events to the Personify Rewards API',
    frequency: '*/5 * * * *',
  },
  PERSONIFY_COMPLETE_LABS_CRON: {
    name: 'PersonifyCompleteLabsCron',
    description: 'Enqueues Personify complete-module reward events for patients whose latest Redshift lab snapshot is ALL_COMPLETED',
    frequency: '0 3 * * *',
  },
  FDA_DOWNLOAD_COMMAND: {
    name: 'FDADownload',
    description: 'Download FDA data',
    frequency: 'Manual',
  },
  GOAL_EXPIRATION_COMMAND: {
    name: 'GoalExpiration',
    description: 'Check goal expiration',
    frequency: '* * * * *',
  },
  GOAL_STATUS_COMMAND: {
    name: 'GoalStatus',
    description: 'Check goal status',
    frequency: '0 0 * * *',
  },
  MESSAGE_COMMAND: {
    name: 'Message',
    description: 'Check for unread messages',
    frequency: '0 * * * *',
  },
  PATIENT_STATUS_COMMAND: {
    name: 'PatientStatus',
    description: 'Check patient statuses',
    frequency: '0 8 * * *',
  },
  RECOMMENDATIONS_COMMAND: {
    name: 'Recommendations',
    description: 'Re-check recommendations',
    frequency: '*/5 * * * *',
  },
  USER_REMINDER_COMMAND: {
    name: 'UserReminder',
    description: 'Check user-reminder emails',
    frequency: '0 16 * * *',
  },
  WEIGHT_REMINDER_COMMAND: {
    name: 'WeightReminder',
    description: 'Check weight-reminder emails',
    frequency: '30 15 * * *',
  },
  FOOD_REMINDER_COMMAND: {
    name: 'FoodReminder',
    description: 'Check food-reminder emails',
    frequency: '35 15 * * *',
  },
  COMPLETE_GOAL_REMINDER_COMMAND: {
    name: 'CompleteGoalReminders',
    description: 'Check complete goals emails',
    frequency: '40 15 * * *',
  },
  CREATE_GOAL_REMINDER_COMMAND: {
    name: 'CreateGoalReminders',
    description: 'Check create goals emails',
    frequency: '45 15 * * *',
  },
  QUESTIONNAIRE_REMINDER_COMMAND: {
    name: 'QuestionnaireReminders',
    description: 'Check questionnaire-reminder emails',
    frequency: '50 15 * * *',
  },
  PATIENT_WEEK_REMINDER_COMMAND: {
    name: 'PatientWeekReminders',
    description: 'Check patient week reminder emails',
    frequency: '55 15 * * *',
  },
  GOOGLE_FIT_COMMAND: {
    name: 'GoogleFit',
    description: 'Fetch data from Google fit api',
    frequency: '*/5 * * * *',
  },
  CLEAN_BLOCKED_TOKENS: {
    name: 'CleanBlockedTokens',
    description: 'Clean expired jwt tokens',
    frequency: '0 8 * * *',
  },
  RPM_BILLING_COMMAND: {
    name: 'RPMBilling',
    description: 'Detect whether RPM Readings Threshold is met',
    frequency: '0 7 * * *',
  },
  FETCH_MOBILE_CONTENT_COMMAND: {
    name: 'FetchMobileContent',
    description: 'Fetch mobile content from Google Sheets API',
    frequency: 'Manual',
  },
  DAILY_CHECK_IN_REMINDER_COMMAND: {
    name: 'DailyCheckInReminder',
    commandPrefix: 'mobile-push-notifications/',
    description: 'Send a daily check-in reminder push notification to patients',
    frequency: '55 23 * * *', // 00:00 UTC corresponds to 4 PM PT
  },
  WEEKLY_SUMMARY_COMMAND: {
    name: 'WeeklySummary',
    commandPrefix: 'mobile-push-notifications/',
    description: 'Send weekly summary push notification to patients',
    frequency: '0 20 * * 4', // 20:00 UTC corresponds to 12 PM PT
  },
  WEEKLY_QUIZ_COMMAND: {
    name: 'WeeklyQuiz',
    commandPrefix: 'mobile-push-notifications/',
    description: 'Send quiz summary push notification to patients',
    frequency: '0 18 * * 2', // 18:00 UTC corresponds to 10 AM PT
  },
  EHR_SYNC_COMMAND: {
    name: 'EhrSync',
    description: 'Sync EHR users data ',
    frequency: '*/5 5-9 * * 4',
  },
  PATIENT_READINGS_COMMAND: {
    name: 'PatientReadingsReminder',
    description: 'Send patient readings to provider',
    frequency: '0 16 * * 1',
  },
  DEVICE_USAGE_REMINDER_COMMAND: {
    name: 'DeviceUsageReminder',
    description: 'Send device usage reminder to all patients (RPM not matters)',
    frequency: '0 5 * * 1,4',
  },
  BIRTHDAY_PUSH_NOTIFICATION: {
    name: 'BirthdayWish',
    commandPrefix: 'mobile-push-notifications/',
    description: 'Send birthday wish push notification to patients',
    frequency: '0 17 * * *', // 17:00 UTC corresponds to 9 AM PT
  },
  UPCOMING_APPOINTMENTS_REMINDER_COMMAND: {
    name: 'UpcomingAppointmentsReminder',
    description: 'send reminder to patients for upcoming appointments',
    frequency: '*/5 * * * *',
  },
  NEW_LEARNING_PUSH_NOTIFICATION: {
    name: 'NewLearningMaterial',
    commandPrefix: 'mobile-push-notifications/',
    description: 'Send new learning material push notification to patients',
    frequency: '0 18 * * 6', // 18:00 UTC corresponds to 10 AM PT, 6 corresponds to Saturday
  },
  MISSING_EHR_IDS_SYNC_COMMAND: {
    name: 'MissingEhrIdsSync',
    description: 'Add missing EHR ids for CWCC patients',
    frequency: 'Manual',
  },
  ORG_TO_ATHENA_SYNC: {
    name: 'SyncOrganizationDataToAthena',
    description: 'Synchronize Evolve organization data to Athena',
    frequency: 'Manual', // temporary changed to manual
  },
  CREATE_MEDICATION_REMINDERS_COMMAND: {
    name: 'CreateMedicationReminders',
    description: 'Create Medication reminders',
    frequency: '*/5 * * * *',
  },
  SEND_MEDICATION_REMINDERS_COMMAND: {
    name: 'SendMedicationReminders',
    description: 'Send Medication reminders',
    frequency: '* * * * *',
  },
  ATHENA_MEDICATIONS_CHANGED_SUBSCRIPTION: {
    name: 'AthenaMedicationsChangedSubscription',
    description: 'Establishes new medications changed subscription for Athena',
    frequency: 'Manual',
  },
  ATHENA_MEDICATIONS_CHANGED_SYNC: {
    name: 'AthenaMedicationsChangedSync',
    description: 'Retrieves data from Athena for any patients with medication changes',
    frequency: '*/5 * * * *',
  },
  ATHENA_PATIENT_VITALS_SYNC: {
    name: 'AthenaPatientVitalsSync',
    description: 'Syncs patient-vitals to Athena',
    frequency: '*/5 * * * *',
  },
  ATHENA_ALLERGY_CHANGED_SUBSCRIPTION: {
    name: 'AthenaAllergyChangedSubscription',
    description: 'Establishes new allergy changed subscription for Athena',
    frequency: 'Manual',
  },
  ATHENA_ALLERGY_CHANGED_SYNC: {
    name: 'AthenaAllergyChangedSync',
    description: 'Retrieves data from Athena for any patients with allergy changes',
    frequency: '*/5 * * * *',
  },
  ATHENA_DIAGNOSIS_CHANGED_SUBSCRIPTION: {
    name: 'AthenaDiagnosisChangedSubscription',
    description: 'Establishes new diagnosis changed subscription for Athena',
    frequency: 'Manual',
  },
  ATHENA_DIAGNOSIS_CHANGED_SYNC: {
    name: 'AthenaDiagnosisChangedSync',
    description: 'Retrieves data from Athena for any patients with diagnosis changes',
    frequency: '*/5 * * * *',
  },
  ATHENA_CHECKLIST_FILES_SYNC: {
    name: 'AthenaChecklistFilesSync',
    description: 'Command to sync patient uploaded files to Athena',
    frequency: '*/15 * * * *',
  },
  CREATE_ATHENA_APPOINTMENTS: {
    name: 'CreateAthenaAppointments',
    description: 'Creates appointments in Athena EHR for any un-synced appointments',
    frequency: '0 22 * * *',
  },
  DEACTIVATE_EXPIRED_MEDICATION_REMINDERS: {
    name: 'DeactivateExpiredMedicationReminders',
    description: 'Deactivates medication reminders that have AOMs expiring on the current day',
    frequency: '0 0 * * *',
  },
  ATHENA_EMERGENCY_CONTACT_SYNC: {
    name: 'AthenaEmergencyContactSync',
    description: 'Synchronizes Emergency Contact data between Evolve and Athena',
    frequency: '0 3 * * *',
  },
  ITERABLE_PATIENT_DATA_SYNC: {
    name: 'IterablePatientDataSync',
    description: 'Syncs Patient Data to Iterable',
    frequency: '0 22 * * *',
  },
  QURATE_PATIENT_DATA_SYNC: {
    name: 'QuratePatientDataSync',
    description: 'Syncs Patient Data to Qurate every hour at the 18th minute mark',
    frequency: '18 0 * * *',
  },
  QURATE_PATIENT_DATA_UPDATE_SYNC: {
    name: 'QuratePatientDataUpdateSync',
    description: 'Syncs Patients Updated Data to Qurate every day at the 30th minute mark',
    frequency: '30 0 * * *',
  },
  ITERABLE_PROVIDER_DATA_SYNC: {
    name: 'IterableProviderDataSync',
    description: 'Syncs Provider Data to Iterable',
    frequency: '0 22 * * *',
  },
  ITERABLE_APPOINTMENT_TRIGGER: {
    name: 'IterableAppointmentTrigger',
    description: 'Triggers Iterable Appointment event',
    frequency: '30 22 * * *',
  },
  ITERABLE_BACKFILL_APPOINTMENTS: {
    name: 'IterableBackfillAppointments',
    description: 'Backfills lastCompleted, lastNoShow, nextScheduled for all patients',
    frequency: 'Manual',
  },
  ITERABLE_BACKFILL_PROVIDER_ZOOMLINKS: {
    name: 'IterableBackfillProviderZoomLinks',
    description: 'Backfills providerZoomLink in nextScheduled for all patients',
    frequency: 'Manual',
  },
  ITERABLE_UPDATE_NEXT_SCHEDULED_APPOINTMENT_FOR_COMPLETED_APPOINTMENTS: {
    name: 'IterableUpdateNextScheduledAppointment',
    description: 'Resets the NextScheduledAppointment the day after an appointment has concluded',
    frequency: '0 */4 * * *',
  },
  WITHINGS_DEVICE_BULK_DEACTIVATION_COMMAND: {
    name: 'WithingsDeviceBulkDeactivation',
    description: 'Bulk deactivate Withings devices for patients',
    frequency: '0 13 * * *', // 13:00 UTC corresponds to 6 AM PT
  },
  WITHINGS_ORDER_DEVICES: {
    name: 'WithingsOrderDevices',
    description: 'This command allows us to order Withings devices for patients.',
    frequency: 'Manual',
  },
  ATHENA_CHECKLIST_CONSENTS_SYNC: {
    name: 'AthenaChecklistConsentsSync',
    description: 'Command to sync patient consent forms that failed initial upload to Athena',
    frequency: '*/20 * * * *',
  },
  WITHINGS_UPDATE_ORDER_STATUSES: {
    name: 'WithingsUpdateOrderStatuses',
    description: 'This command gets updated order information for shipped Withings Orders',
    frequency: '0 22 * * *',
  },
  ATHENA_SIGNED_OFF_ORDER_SUBSCRIPTION: {
    name: 'AthenaSignedOffOrderSubscription',
    description: 'Establishes new signed off order subscription for Athena',
    frequency: 'Manual',
  },
  OBSERVATION_TO_PATIENT_VITALS: {
    name: 'ObservationToPatientVitals',
    description: 'Sync observation payload to patient vitals',
    frequency: '* * * * *',
  },
  ATHENA_FETCH_WITHINGS_ORDERS: {
    name: 'AthenaCreateWithingsOrdersCommand',
    description: 'Process Athena signed orders for KIT orders to Withings',
    frequency: '15 */1 * * *',
  },
  ATHENA_FETCH_ORDERS: {
    name: 'AthenaFetchOrders',
    description: 'Gets Athena signed off orders and save them to Athena Signed Off API Logs db table',
    frequency: '6 * * * *',
  },
  ATHENA_FETCH_APPT_DATA: {
    name: 'AthenaFetchApptData',
    description: 'Gets Athena data for appointments',
    frequency: '8 * * * *',
  },
  SYNC_EMPANELMENT_PROVIDER_MAPPINGS: {
    name: 'SyncProviderEmpanelmentMappings',
    description:
      'Pulls data from the google sheet (https://docs.google.com/spreadsheets/d/1ZYN7I9If_MaNjU9pLYa5PZBfAaSGnBT2spbR26_Ish8/edit#gid=0) to map providers to their respective empanelment tables',
    frequency: '40 * * * * ',
  },
  CREATE_ATHENA_INDIVIDUAL_WITHINGS_ORDERS: {
    name: 'CreateAthenaIndividualWithingsOrders',
    description: 'Process Athena signed orders for individual orders to Withings.',
    frequency: '0 * * * *',
  },
  ATHENA_PATIENT_CASE_CHANGED_SUBSCRIPTION: {
    name: 'AthenaPatientCaseChangedSubscription',
    description: 'Establishes patient case changed subscription for Athena',
    frequency: 'Manual',
  },
  ATHENA_PATIENT_CASE_CHANGED_SYNC: {
    name: 'AthenaPatientCaseChangedSync', // Clinical Messaging Cron Job
    description: 'Retrieves data from Athena for patient case changes',
    frequency: '* * * * *',
  },
  SYNC_PATIENT_CARE_SUMMARY: {
    name: 'SyncPatientCareSummary', // Clinical Messaging Cron Job
    description: 'Syncs Patient Care Summary letters from Athena for Completed Appointments',
    frequency: '*/5 * * * *', // every 5 minutes
  },
  CREATE_NEW_PATIENT_CASE_WITH_ATHENA: {
    name: 'CreateNewPatientCaseWithAthena', // Clinical Messaging Cron Job
    description: 'Creates new patient cases for new conversations',
    frequency: '* * * * *',
  },
  CREATE_NEW_REPLIES_CASE_WITH_ATHENA: {
    name: 'CreateNewRepliesWithAthena', // Clinical Messaging Cron Job
    description: 'Creates action note for new replies',
    frequency: '* * * * *',
  },
  SYNC_OPEN_ATHENA_PATIENT_CASE: {
    name: 'SyncOpenAthenaPatientCases', // Clinical Messaging Cron Job
    description: 'For each conversation, Sync the Open patient case from Athena',
    frequency: '0 3 * * *', // To run every day at 3:00 AM
  },
  SYNC_ATTACHMENTS_WITH_ATHENA: {
    name: 'SyncAttachmentsWithAthena', // Clinical Messaging Cron Job
    description: "Syncs message's Attachments with athena",
    frequency: '* * * * *',
  },
  SYNC_PATIENT_PORTAL_ACCESS: {
    name: 'SyncAthenaPortalAccess', // Clinical Messaging Cron Job
    description: 'Synchronization of Patient Portal Access with Evolve',
    frequency: '0 3 * * *',
  },
  CONFIRM_APPOINTMENTS_WITH_ATHENA: {
    name: 'ConfirmAppointmentsInAthena',
    description: 'Confirms Appointments in Athena',
    frequency: '0 3 * * *',
  },
  INSERT_SURGERY_DATA: {
    name: 'InsertSurgeryData',
    description: 'This command allows us to insert tables from a google sheet to build the surgeries and medications_v2 tables',
    frequency: 'Manual',
  },
  COMPARE_AND_UPDATE_MEDICATIONS_DATA: {
    name: 'CompareAndUpdateMedicationsData',
    description: 'This command allows us to compare medications table data with google sheet to update the medications tables',
    frequency: 'Manual',
  },
  BACKFILL_LAB_DOCUMENTS_IDP: {
    name: 'BackfillLabDocumentsIdp',
    description: 'One-time backfill command to reprocess lab documents through IDP and downstream Athena sync',
    frequency: 'Manual',
  },
  AUTOMATED_AOM_VALIDATION: {
    name: 'AutomatedAOMValidation',
    description: 'This cron job synchronizes AOM medications from Athena to Evolve.',
    frequency: '0 3 * * *',
  },
  ACUITY_SCORING: {
    name: 'AcuityScoring',
    description: 'This cron job completes incomplete acuity records and creates rescores for patients with year-old acuity records.',
    frequency: '0 6 * * *',
  },
  PROCESS_CLAIMS: {
    name: 'ProcessClaims',
    description: 'Generates claims for all pending payment transactions',
    frequency: '0 5 14 * *',
  },
  POST_PAYMENT_TO_ATHENA: {
    name: 'PostPaymentToAthena',
    description: 'Posts payment transactions to Athena for stored cards',
    frequency: '0 5 15,22 * *',
  },
  GENERATE_ATHENA_PAYMENT_SCHEDULE: {
    name: 'GenerateAthenaPaymentSchedule',
    description: 'Generates a payment schedule for to post toAthena',
    frequency: '0 5 13 * *',
  },
  GENERATE_ATHENA_PAYMENT_REMINDER: {
    name: 'GenerateAthenaPaymentReminder',
    description: 'Sends payment reminders to autoPay patients with any pending transactions (1 reminder per patient)',
    frequency: '0 5 14 * *',
  },
  CHECK_CLAIM_BALANCES: {
    name: 'CheckClaimBalances',
    description: 'Checks PENDING claims and updates status to COMPLETED if fully paid (AutoPay and Self-Pay)',
    frequency: '0 3 1-14,17-31 * *', // Exclude 14th and 15th of the month ( 15th and 16th in UTC time as this runs at 10/11pm Eastern Time)
  },
  EMAIL_RECEIPT_TO_PATIENT: {
    name: 'EmailReceiptToPatient',
    description: 'Sends email receipts to patients after payment processing',
    frequency: '*/15 5-23 15,22 * *',
  },
  LAB_REQUEST_STATUS_POLLING: {
    name: 'LabRequestStatusPolling',
    description: 'Poll Athena for lab order status changes and update lab request states',
    frequency: '*/15 * * * *',
  },
  STALE_IDP_LAB_DOCUMENTS_REENQUEUE: {
    name: 'StaleIdpLabDocumentsReenqueue',
    description: 'Re-enqueue stale IDP lab documents stuck in SUBMITTED_TO_IDP/PROCESSING for over 30 minutes',
    frequency: '0 * * * *',
  },
  BACKFILL_SOCT_PATIENTS_INTO_FLYTE_BILLING_DEPARTMENT: {
    name: 'BackfillSoCTPatientsIntoFlyteBillingDepartment',
    description: 'Backfills SoCT patients into Flyte Medical Billing Department',
    frequency: 'Manual',
  },
  BACKFILL_DEDU_ADMINS_COMMAND: {
    name: 'BackfillDeduAdmins',
    description: 'One-time backfill of DEDU mappings for admin users',
    frequency: 'Manual',
  },
  SEND_ATHENA_PORTAL_INVITE: {
    name: 'SendAthenaPortalInvite', // Clinical Messaging Cron Job
    description: 'Sends Athena Portal Invite to active non-portal patients',
    frequency: 'Manual',
  },
  ATHENA_SYNC_PREP_STATUS: {
    name: 'AthenaSyncPrepStatus',
    description: 'Syncs prep status from Athena to Evolve',
    frequency: '8 * * * *',
  },
  SELF_SCHEDULING_BACKFILL: {
    name: 'SelfSchedulingBackfill',
    description: 'Manual backfill command for self-scheduling functionality by organization and payor',
    frequency: 'Manual',
  },
  FLYTECIRCLE_GROUP_VISIT_BACKFILL: {
    name: 'FlyteCircleGroupVisitBackfill',
    description: 'Manual backfill of FlyteCircle group visit sessions and placeholder appointments from provider blocked hours',
    frequency: 'Manual',
  },
  ITERABLE_BACKFILL_ACUITY: {
    name: 'IterableBackfillAcuity',
    description: 'Manual backfill of acuity values into Iterable patient data fields',
    frequency: 'Manual',
  },
  ITERABLE_BACKFILL_VITALS: {
    name: 'IterableBackfillVitals',
    description: 'Manual backfill of lastWeightLogged and latestBPReading into Iterable patient data fields',
    frequency: 'Manual',
  },
  WITHINGS_MANAGE_NOTIFICATION_SUBSCRIPTIONS: {
    name: 'WithingsManageNotificationSubscriptions',
    description: 'Manage Withings notification subscriptions for all enabled users',
    frequency: '0 12 * * 5',
  },
  BACKFILL_ACUITY: {
    name: 'BackfillAcuity',
    description: 'Backfills acuity values from Athena to Evolve',
    frequency: 'Manual',
  },
  MASS_PATIENT_DEACTIVATION: {
    name: 'MassPatientDeactivation',
    description: 'Mass deactivate patients from CSV (Flyte + Athena). Input: MassDeactivationJan2025.csv; output: ResultMassDeactivationJan2025.csv',
    frequency: 'Manual',
  },
  ATHENA_APPOINTMENT_DATA_BACKFILL: {
    name: 'AthenaAppointmentDataBackfill',
    description: 'Sets isAppointmentComplete on Flyte appointments that Athena shows as Charge Entered (status 4)',
    frequency: '0 5 * * 0', // 05:00 UTC Sunday
  },
  ITERABLE_DEVICE_INFO_SYNC: {
    name: 'IterableDeviceInfoSync',
    description: 'Syncs Withings device information (device name, shipping status, active status) to Iterable patient data fields',
    frequency: '0 1 * * *',
  },
  ITERABLE_REDSHIFT_SYNC: {
    name: 'IterableRedshiftSync',
    description:
      'Syncs warehouse-derived fields from Redshift into Iterable patient data fields (lab status, Athena RD Group Visit / RefusingRD). Field groups are registered in modules/iterable/redshift-sync/sync-groups.ts',
    frequency: '0 2 * * *',
  },
  SYNC_POST_VISIT_CARE_PLAN: {
    name: 'SyncPostVisitCarePlan',
    description: 'Full-refreshes post_visit_care_plan in Postgres from silver.clinical_encounter_action_plan_extracted in Redshift',
    frequency: 'Manual',
  },
  SYNC_INITIAL_CARE_PLANS: {
    name: 'SyncInitialCarePlans',
    description: 'Sync initial care plans from Redshift into local Postgres cache table',
    frequency: 'Manual',
  },
};
